define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.removeClass = exports.addClass = void 0;
    const addClass = (element, className) => {
        const arr = element.className.split(' ');
        if (arr.indexOf(className) === -1) {
            element.className += ' ' + className;
        }
    };
    exports.addClass = addClass;
    const removeClass = (element, className) => {
        element.className = element.className.replace(className, '');
    };
    exports.removeClass = removeClass;
});
//# sourceMappingURL=domutils.js.map